export default __webpack_public_path__ + "static/media/img-0767-sweden-full-face.67967cac.png";